import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  useSeo(
    "页面未找到 - 看片网站",
    "抱歉，你访问的页面不存在。返回看片网站首页，继续浏览丰富的电影与电视剧资源。",
    "404,页面未找到,看片网站"
  );

  return (
    <div className="mx-auto flex max-w-7xl flex-col items-center justify-center px-4 py-24 text-center md:px-6">
      <span className="font-heading text-7xl font-black text-primary-100 md:text-9xl">404</span>
      <h1 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
        这个页面走丢了
      </h1>
      <p className="mt-3 text-sm text-foreground-600">
        你访问的页面可能已被移除或链接有误，不妨回到首页继续挑选好片。
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line leading-none"></i>
          返回首页
        </Link>
        <Link
          to="/category"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-6 py-3 text-sm font-bold text-primary-700 transition-colors hover:bg-primary-50"
        >
          <i className="ri-apps-2-line leading-none"></i>
          浏览分类
        </Link>
      </div>
    </div>
  );
}